var exports = {
  "XG": "ChannelAttachmentArea.module__scroller___VXRHaT",
  "IP": "ChannelAttachmentArea.module__channelAttachmentArea___VXRHaT",
  "Se": "ChannelAttachmentArea.module__upload___VXRHaT",
  "PO": "ChannelAttachmentArea.module__uploadContainer___VXRHaT",
  "il": "ChannelAttachmentArea.module__mediaContainer___VXRHaT",
  "BA": "ChannelAttachmentArea.module__clickableMedia___VXRHaT",
  "q2": "ChannelAttachmentArea.module__spoilerContainer___VXRHaT",
  "R": "ChannelAttachmentArea.module__hidden___VXRHaT",
  "rP": "ChannelAttachmentArea.module__hiddenSpoiler___VXRHaT",
  "pR": "ChannelAttachmentArea.module__spoilerWarning___VXRHaT",
  "Qx": "ChannelAttachmentArea.module__obscureWarning___VXRHaT",
  "Qu": "ChannelAttachmentArea.module__spoilerInnerContainer___VXRHaT",
  "CU": "ChannelAttachmentArea.module__spoilerWrapper___VXRHaT",
  "p6": "ChannelAttachmentArea.module__spoiler___VXRHaT",
  "$_": "ChannelAttachmentArea.module__media___VXRHaT",
  "_A": "ChannelAttachmentArea.module__tags___VXRHaT",
  "H6": "ChannelAttachmentArea.module__filenameContainer___VXRHaT",
  "iW": "ChannelAttachmentArea.module__filename___VXRHaT",
  "VF": "ChannelAttachmentArea.module__fileDetails___VXRHaT",
  "Ov": "ChannelAttachmentArea.module__fileSize___VXRHaT",
  "i_": "ChannelAttachmentArea.module__fileExtension___VXRHaT",
  "TC": "ChannelAttachmentArea.module__actionBarContainer___VXRHaT",
  "KY": "ChannelAttachmentArea.module__actionBar___VXRHaT" + " " + __webpack_require__(790033)["KE"],
  "x6": "ChannelAttachmentArea.module__button___VXRHaT" + " " + __webpack_require__(790033)["AS"],
  "OR": "ChannelAttachmentArea.module__danger___VXRHaT",
  "le": "ChannelAttachmentArea.module__actionBarIcon___VXRHaT",
  "s3": "ChannelAttachmentArea.module__altTag___VXRHaT",
  "Kk": "ChannelAttachmentArea.module__icon___VXRHaT",
  "Dp": "ChannelAttachmentArea.module__iconImage___VXRHaT",
  "vt": "ChannelAttachmentArea.module__videoModal___VXRHaT",
  "j": "ChannelAttachmentArea.module__videoContainer___VXRHaT",
  "yF": "ChannelAttachmentArea.module__divider___VXRHaT",
  "mg": "ChannelAttachmentArea.module__dropIndicatorLeft___VXRHaT",
  "l_": "ChannelAttachmentArea.module__dropIndicatorRight___VXRHaT",
};

module.exports = exports;
